// Real portfolio data for Francesco Maria De Lucia

export const heroData = {
  name: "zapoida francis",
  tagline: "Audio Engineer • Music Producer • Musician",
  description: "Audio professional based in Berlin, blending creativity with technical expertise to craft immersive soundscapes and outstanding sonic\u00A0experiences.",
  location: "Berlin, Germany",
  email: "francescomdelucia@yahoo.com",
  phone: "+39 3518157754",
  linkedin: "Francesco Maria De Lucia"
};

export const roles = [
  { id: 'all', name: 'All Works' },
  { id: 'sound-designer', name: 'Sound Designer' },
  { id: 'mixing-engineer', name: 'Mixing Engineer' },
  { id: 'mastering-engineer', name: 'Mastering Engineer' },
  { id: 'guitar-player', name: 'Guitar Player' },
  { id: 'bass-player', name: 'Bass Player' },
  { id: 'music-producer', name: 'Music Producer' },
  { id: 'music-composer', name: 'Music Composer' },
  { id: 'studio-assistant', name: 'Studio Assistant' }
];

export const works = [
  // 2026
  {
    id: 19,
    title: 'Yousician / GuitarTuna',
    artist: 'Music Learning Platform',
    role: ['guitar-player'],
    type: 'tiktok',
    tiktokUrl: 'https://www.tiktok.com/@yousician/video/7642251774681812246',
    image: '/images/yousician_guitartuna.jpg',
    description: 'Promotional videos for the music learning apps Yousician and GuitarTuna.',
    badge: '1M+ views',
    year: 2026
  },
  {
    id: 18,
    title: 'Marko Bošnjak',
    artist: 'Eurovision 2025 Participant',
    role: ['guitar-player'],
    type: 'no-link',
    image: 'https://customer-assets.emergentagent.com/job_sonic-portfolio-13/artifacts/osnc0ikf_markobosnjakjpeg.jpeg',
    description: 'Touring live as guitar player',
    year: 2026
  },
  // 2025
  {
    id: 1,
    title: '"Sleeping Without Dreams" - 5-Track EP',
    artist: 'Rose Eva ft. Nic Storm',
    role: ['mixing-engineer', 'guitar-player'],
    type: 'spotify-album',
    spotifyUrl: 'https://open.spotify.com/album/596AsVsJfeo5DOQGAve8Ol?si=vrsxhHXcTJW19fJERGiz2g',
    spotifyId: '596AsVsJfeo5DOQGAve8Ol',
    image: 'https://image-cdn-fa.spotifycdn.com/image/ab67616d00001e02f42a4e0541fb3df25f11331b',
    description: 'Mix of the full EP, and guitar performance on "28 Days Later"',
    year: 2025
  },
  {
    id: 2,
    title: '"Man ! Really Am" - Single',
    artist: 'DARIO',
    role: ['music-producer', 'mixing-engineer', 'guitar-player', 'bass-player'],
    type: 'spotify-track',
    spotifyUrl: 'https://open.spotify.com/track/6Z89VmctctBLADdckeE4cU?si=3d7d4784fae440f6',
    spotifyId: '6Z89VmctctBLADdckeE4cU',
    image: 'https://image-cdn-ak.spotifycdn.com/image/ab67616d00001e02d30c4b9031d953a756e8d474',
    description: 'Full production: arrangement, recording, guitar/bass performance and audio mixing',
    year: 2025
  },
  {
    id: 3,
    title: 'Low-Top 00 - Promo Video',
    artist: 'Affinity Space Design Studio',
    role: ['sound-designer'],
    type: 'instagram',
    instagramUrl: 'https://www.instagram.com/reel/DKwzjHotAEU/',
    image: 'https://customer-assets.emergentagent.com/job_sonic-portfolio-13/artifacts/v276pj67_lowtop00.png',
    description: 'Sound design for footwear innovation design asset promo video',
    year: 2025
  },
  // 2024
  {
    id: 4,
    title: '"Twister" - Single',
    artist: 'Suga x Spice (Nayeli, Rose Eva)',
    role: ['mixing-engineer', 'mastering-engineer'],
    type: 'spotify-track',
    spotifyUrl: 'https://open.spotify.com/track/0vpVDyoXXEdvFpFBynuFrA?si=d15d5aca05da4ea9',
    spotifyId: '0vpVDyoXXEdvFpFBynuFrA',
    image: 'https://image-cdn-fa.spotifycdn.com/image/ab67616d00001e02d02b40ad1de84d5b9b155e2c',
    description: 'Mix and master',
    year: 2024
  },
  {
    id: 5,
    title: '"Freischwimmer" - Single',
    artist: 'Garlev',
    role: ['guitar-player', 'bass-player'],
    type: 'spotify-track',
    spotifyUrl: 'https://open.spotify.com/track/2Zo6tnCuiueYxzzFHngKvP?si=07ffd9c2b51a4275',
    spotifyId: '2Zo6tnCuiueYxzzFHngKvP',
    image: 'https://image-cdn-ak.spotifycdn.com/image/ab67616d00001e0282978aca8eb2d8e0db13e0fc',
    description: 'Guitar and bass performance',
    year: 2024
  },
  {
    id: 6,
    title: '"Für immer" - Single',
    artist: 'Nic Storm, Ian Silva',
    role: ['mastering-engineer'],
    type: 'spotify-track',
    spotifyUrl: 'https://open.spotify.com/track/2TSS7JTUJgWllTiwqFXaJg?si=549bf8dd0ba84bd2',
    spotifyId: '2TSS7JTUJgWllTiwqFXaJg',
    image: 'https://image-cdn-fa.spotifycdn.com/image/ab67616d00001e02f3804fe8865fbb670ea0ee29',
    description: 'Master',
    year: 2024
  },
  {
    id: 7,
    title: '"Tofhaa - mkssr Remix" - Single',
    artist: 'Sunken Cages, Makossiri',
    role: ['mastering-engineer'],
    type: 'spotify-track',
    spotifyUrl: 'https://open.spotify.com/track/4q8AV8e9jbJjGG95ImMtHt?si=bc2125ce0f744a65',
    spotifyId: '4q8AV8e9jbJjGG95ImMtHt',
    image: 'https://image-cdn-ak.spotifycdn.com/image/ab67616d00001e02468dd98a6225a345ab872c99',
    description: 'Master',
    year: 2024
  },
  {
    id: 8,
    title: '"Milky Boom Boom" - Single',
    artist: 'Sky Deep',
    role: ['mixing-engineer', 'mastering-engineer'],
    type: 'bandcamp',
    bandcampUrl: 'https://refugeworldwide.bandcamp.com/track/sky-deep-milky-boom-boom',
    image: 'https://f4.bcbits.com/img/a0374684974_16.jpg',
    description: 'Mix and master',
    year: 2025
  },
  // 2023
  {
    id: 9,
    title: '"Flashbacks" - Theme Song',
    artist: '"Loving Her" (ZDF)',
    role: ['bass-player'],
    type: 'link',
    externalUrl: 'https://www.zdf.de/serien/loving-her-102?staffel=2',
    image: 'https://customer-assets.emergentagent.com/job_sonic-portfolio-13/artifacts/970yy8c1_flashbacks.jpg',
    description: 'Bass performance for Season 2 theme song',
    year: 2023
  },
  {
    id: 10,
    title: '"New Mistake", "Love To Live Another"',
    artist: '"Loving Her" (ZDF)',
    role: ['music-composer', 'music-producer', 'mixing-engineer'],
    type: 'link',
    externalUrl: 'https://www.zdf.de/serien/loving-her-102?staffel=2',
    image: 'https://customer-assets.emergentagent.com/job_sonic-portfolio-13/artifacts/y77kma2o_new%20mistake%20and%20love%20to%20live%20another.jpeg',
    description: 'Composition and production of two original pieces of the soundtrack for international broadcasting (collaboration with Sky Deep)',
    year: 2023
  },
  // 2022
  {
    id: 11,
    title: '"AQUAPAN" - Immersive Installation',
    artist: 'The Lighthouse of Digital Art',
    role: ['sound-designer', 'music-producer'],
    type: 'no-link',
    image: 'https://customer-assets.emergentagent.com/job_sonic-portfolio-13/artifacts/14ysqzn1_acquapan.png',
    description: 'Production, sound design, creation, and hosting of immersive sound and visual installation at Berlin modern art museum',
    year: 2022
  },
  // 2021
  {
    id: 14,
    title: '"Bed of Bones" - Single',
    artist: 'Femia',
    role: ['music-producer', 'guitar-player', 'bass-player', 'studio-assistant'],
    type: 'spotify-track',
    spotifyUrl: 'https://open.spotify.com/track/60ErzDJpPjd9e3xR71yXtV?si=f574e9a455114f4a',
    spotifyId: '60ErzDJpPjd9e3xR71yXtV',
    image: 'https://image-cdn-fa.spotifycdn.com/image/ab67616d00001e02e34ac8054a2aa5036307b08a',
    description: 'Arrangement, production, guitar/bass performance, and studio assistance',
    year: 2021
  },
  {
    id: 15,
    title: '"Can\'t Love You Anyless" - Single',
    artist: 'Femia',
    role: ['music-producer', 'guitar-player', 'bass-player', 'studio-assistant'],
    type: 'spotify-track',
    spotifyUrl: 'https://open.spotify.com/track/1Rk7tHPheeyQhVADu3F3yS?si=b7022179e5c348eb',
    spotifyId: '1Rk7tHPheeyQhVADu3F3yS',
    image: 'https://image-cdn-fa.spotifycdn.com/image/ab67616d00001e029c2281ffc38e1f5b639aaed6',
    description: 'Arrangement, production, guitar/bass performance, and studio assistance',
    year: 2021
  },
  // 2020
  {
    id: 12,
    title: '"Mariposa" - VR/AR Experience',
    artist: 'Affinity Space Design Studio',
    role: ['sound-designer'],
    type: 'no-link',
    image: 'https://customer-assets.emergentagent.com/job_sonic-portfolio-13/artifacts/omautujk_mariposa.png',
    description: 'Immersive sound design for virtual and augmented reality experience',
    year: 2020
  },
  {
    id: 13,
    title: '"Bon Courage!" - 6-Track EP',
    artist: 'La Festa',
    role: ['studio-assistant'],
    type: 'spotify-album',
    spotifyUrl: 'https://open.spotify.com/album/4qAicwbNfoLugYSTRJm5kf?si=SjJZwUVBTJ2-xut3MJaZhQ',
    spotifyId: '4qAicwbNfoLugYSTRJm5kf',
    image: 'https://image-cdn-ak.spotifycdn.com/image/ab67616d00001e026646939dbb3c8e7482ec5662',
    description: 'Recording studio assistance',
    year: 2020
  },
  {
    id: 16,
    title: '"Trouble\'s Coming" - Single',
    artist: 'Femia',
    role: ['music-producer', 'guitar-player', 'bass-player', 'studio-assistant'],
    type: 'spotify-track',
    spotifyUrl: 'https://open.spotify.com/track/6yoveVjzC2kndMJPOBz71a?si=b9875a28c50d4582',
    spotifyId: '6yoveVjzC2kndMJPOBz71a',
    image: 'https://image-cdn-fa.spotifycdn.com/image/ab67616d00001e023d1e07701ec7223cbd29b830',
    description: 'Arrangement, production, guitar/bass performance, and studio assistance',
    year: 2020
  },
  // 2019
  {
    id: 17,
    title: 'Daudia',
    artist: 'Electropop Duo',
    role: ['guitar-player'],
    type: 'no-link',
    image: 'https://customer-assets.emergentagent.com/job_sonic-portfolio-13/artifacts/m44v9yhj_daudia.jpg',
    description: 'Guitar performance for recording sessions and live tours',
    year: 2019
  }
];

export const cvData = {
  pdfUrl: "/documents/CV Francesco M. De Lucia.pdf",
  experience: [
    {
      title: "Consultant",
      company: "Yousician",
      period: "May 2026 - Present",
      description: "Realisation of promotional video content for the music learning platforms Yousician and GuitarTuna."
    },
    {
      title: "Guitar Teacher",
      company: "Musikschule Behm, Bertheau & Morgenstern",
      period: "Feb 2026 - Present",
      description: "Guitar instruction and music education."
    },
    {
      title: "Founder Member, Audio Engineer, Musician, Sound Artist",
      company: "Affinity Space Design Studio",
      period: "Jan 2025 - Present",
      description: "Multimedia design studio. Audio engineering, sound design, artistic collaborations."
    },
    {
      title: "Music Producer, Audio Engineer, Session Musician, Guitar Teacher",
      company: "Self-Employed",
      period: "2019 - Present",
      description: "Music production, audio engineering, guitar and bass session work, guitar teaching for various clients and projects."
    },
    {
      title: "Venue Sound Technician",
      company: "The Lighthouse of Digital Arts & New Media Art Center",
      period: "Apr 2025 - May 2025",
      description: "Sound technician for digital art museum events, handling setup, soundchecks, equipment maintenance."
    },
    {
      title: "Studio Assistant, Audio Engineer",
      company: "Sky Deep's Audio Production Studio",
      period: "Mar 2023 - Dec 2024",
      description: "Studio assistance and audio engineering for soundtracks, audio post-production, mixing, recording, logistics."
    },
    {
      title: "Guitar Teacher, Studio Assistant, Music Educator",
      company: "Drop In (Forum für interkulturelle und politische Bildung)",
      period: "Oct 2022 - Dec 2022",
      description: "Guitar classes, workshops and studio support."
    }
  ],
  education: [
    {
      degree: "Bachelor's Degree (Hons) in Music Production",
      institution: "BIMM Institute",
      year: "Sep 2021 - Jul 2024",
      details: "Audio production, sound engineering, mixing and mastering, sound design, cultural studies in the creative industries."
    },
    {
      degree: "Bachelor's Degree in Jazz Guitar",
      institution: "Conservatory 'N. Sala'",
      year: "Oct 2017 - Oct 2020",
      details: "Guitar performance, music composition and arrangement, history of music, classical and modern music knowledge, big band arranging."
    }
  ],
  skills: [
    "Audio Recording & Editing",
    "Sound Design",
    "Mixing & Mastering",
    "Immersive Audio",
    "Music Composition",
    "Music Arrangement",
    "Ableton Live",
    "Pro Tools",
    "Logic Pro X",
    "Songwriting",
    "Guitar Performance",
    "Bass Performance",
    "Music Theory",
    "Project Management",
    "Photo & Video Editing",
    "DaVinci Resolve",
    "Final Cut Pro X",
    "Premiere Pro"
  ],
  languages: [
    { language: "Italian", level: "Native" },
    { language: "English", level: "Fluent" },
    { language: "German", level: "Basic/Conversational" }
  ],
  personalSkills: [
    "Quick and Effective",
    "Reliable",
    "Professional",
    "Team Player",
    "Creative Spirit",
    "Problem-Solver",
    "Good Communicator"
  ]
};

export const references = [
  {
    name: "Vasily Fedotov",
    role: "Founder & Managing Director",
    company: "KHROMA Vienna / The Lighthouse of Digital Art",
    quote: "Francesco demonstrates high technical competence, reliability, and self-responsibility. His structured work method and professional interaction with teams and artists make him a valuable asset.",
    pdfUrl: "/documents/Reference_Lighthouse.pdf"
  },
  {
    name: "Sky Deep",
    role: "Multi-Media Technical Artist",
    company: null,
    quote: "Francesco was an invaluable asset who consistently demonstrated exceptional skill, dedication, and professionalism. His understanding of music arrangement, studio equipment, and audio editing software is remarkable.",
    pdfUrl: "/documents/Reference_Sky_Deep.pdf"
  },
  {
    name: "Dario Besirevic",
    role: "Singer/Songwriter / Musical Director / Performer",
    company: null,
    quote: "Francesco was a great asset in the composition and production of my debut single. His professionalism, efficient project execution, and outstanding communication skills created the perfect balance.",
    pdfUrl: "/documents/Reference_Dario.pdf"
  },
  {
    name: "Nic Storm",
    role: "Music Producer / Recording Artist",
    company: null,
    quote: "Francesco's performance as a mastering engineer was exemplary. His excellent communication skills and prompt understanding of vision consistently resulted in high-quality work that exceeded expectations.",
    pdfUrl: "/documents/Reference_Nic.pdf"
  }
];

export const soloProject = {
  name: "Solo Artistic Project",
  description: "Coming soon - Stay tuned for my personal artistic exploration blending experimental sounds and creative vision.",
  bio: "This section will showcase my solo work including original songs, music videos, interviews, and visual albums.",
  songs: [],
  videos: [],
  interviews: [],
  musicFilm: null
};
